module.exports = __webpack_public_path__ + "img/product3.a0e40011.jpg";